import Entity from "../../../../model/Entity"
import { RemoteEvaluateContext } from "../../model/RemoteEvaluateContext"
import { EntityDto, EntityEvaluateRequestDto } from "../../model/dto"
import WorkspaceEvaluateRequest from "../WorkspaceEvaluateRequest"

/** An entity (partial) evaluation request: the user context plus the specific entities to resolve. */
export class PartialWorkspaceEvaluateRequest implements WorkspaceEvaluateRequest {
  constructor(readonly context: RemoteEvaluateContext, readonly entities: Entity[]) {}

  toDto(): EntityEvaluateRequestDto {
    const entities: EntityDto[] = this.entities.map((it) => ({ type: it.serviceType, id: it.id }))
    return {
      context: this.context.toDto(),
      entities
    }
  }
}
